import Reflux from "reflux";
import CookieLawActions from "../actions/CookieLawActions";
import ContentService from "../clients/ContentServiceClient";
import * as CookieLawUtil from "../utils/CookieLawUtil";
import * as TrackingUtil from "../utils/TrackingUtil";

import { CookieLaw } from "../datatypes/CookieLaw";

type State = {
    isLoading: boolean;
    cookieLaw: CookieLaw | null | undefined;
    accepted: boolean;
};
let state: State;

const CookieLawStore = Reflux.createStore({
    init() {
        state = this.getEmptyState();
        this.listenTo(CookieLawActions.loadCookieLaw, this.loadCookieLaw);
        this.listenTo(CookieLawActions.acceptCookieLaw, this.acceptCookieLaw);
    },

    loadCookieLaw(country: string, locale: string) {
        if (state.isLoading || state.cookieLaw) {
            return;
        }

        state.isLoading = true;
        ContentService.getCookieLawDisclaimer(country, locale)
            .then(r => this.loadCookieLawSuccess(r))
            .catch(e => this.loadCookieLawError(e));
    },

    acceptCookieLaw(cookieLaw: CookieLaw) {
        CookieLawUtil.accept(cookieLaw);
        this.trigger();
    },

    loadCookieLawSuccess(response: CookieLaw) {
        state.isLoading = false;
        state.cookieLaw = response;
        state.accepted = CookieLawUtil.createDefaultCookie(response);
        this.trigger();
    },

    loadCookieLawError(e: any) {
        state = this.getEmptyState();
        if (!e || e.status !== 404) {
            // 404 is fine e.g. for TR
            TrackingUtil.trackUIError("CookieLawStore", "Loading of cookie law failed.", e);
        }
        this.trigger();
    },

    getEmptyState(): State {
        return {
            isLoading: false,
            cookieLaw: undefined,
            accepted: false
        };
    },

    getInitialState() {
        // used in our store connect hack
        return {
            cookieLaw: state.cookieLaw,
            accepted: false
        };
    }
});

export default CookieLawStore;
